import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { icon } from '@components/icon/icon.interface';

export interface ButtonConfig {
  class?: string;
  disabled?: boolean;
  icon?: icon;
  iconPosition: 'left' | 'right';
  isIconShown?: boolean;
  id?: string;
  label: string;
  style: 'primary' | 'secondary' | 'tertiary';
  type: 'button' | 'submit';
  clicked: EventEmitter<void>;
  onClick: () => void;
  setStyle: () => string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-button',
  templateUrl: './button.component.html',
})
export class ButtonComponent implements ButtonConfig {
  @Input() class?: string;
  @Input() disabled = false;
  @Input() icon?: icon;
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() isIconShown = false;
  @Input() id?: string;
  @Input() label: string;
  @Input() style: 'primary' | 'secondary' | 'tertiary' = 'tertiary';
  @Input() type: 'button' | 'submit' = 'button';
  @Output() clicked = new EventEmitter<void>();

  onClick(): void {
    this.clicked.emit();
  }

  setStyle(): string {
    switch (this.style) {
      case 'primary':
        return 'primary';
      case 'secondary':
        return 'outline-primary';
      case 'tertiary':
        return 'link';
    }
  }
}
